import { render } from "./EditorControls.vue?vue&type=template&id=abdd9da0&scoped=true"
import script from "./EditorControls.vue?vue&type=script&lang=js"
export * from "./EditorControls.vue?vue&type=script&lang=js"

import "./EditorControls.vue?vue&type=style&index=0&id=abdd9da0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdd9da0"]])

export default __exports__